// extracted by mini-css-extract-plugin
export default {"cardLabel":"card-label-module__cardLabel--yIx3x","tooltip":"card-label-module__tooltip--Sa5Pq","ReviewersToken":"card-label-module__ReviewersToken--Ohwqj"};